var lazyLoadInstance = (function() {
    return new LazyLoad({
        restore_on_error: true,
        thresholds: "500px 50%",
    });
})();